import * as DATE from 'date-fns';
export var getExpirationWithinWeek = function getExpirationWithinWeek(expires, current) {
  if (expires.toString() === 'Invalid Date') return null;
  if (DATE.differenceInWeeks(expires, current) >= 1) return null;
  if (DATE.differenceInSeconds(expires, current) <= 0) return null;
  return DATE.formatDistance(expires, current);
};